var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.commissionMeta)?_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('v-chip',_vm._g({attrs:{"small":"","color":_vm.commissionMeta.color}},on))]}}],null,false,3488004420)},[_c('span',[_vm._v(_vm._s(_vm.commissionMeta.label))])]):_c('span',[_vm._v("-")])
}
var staticRenderFns = []

export { render, staticRenderFns }